import { useId } from 'react';
import clsx from 'clsx';

import { Radio } from './Radio';

/**
 * @param {{
 *   title?: string | React.ReactNode;
 *   name?: string;
 *   items?: {
 *     value: string | number;
 *     label?: string;
 *   }[];
 *   direction?: 'row' | 'column';
 *
 *   value: string | number;
 *   onSelect: (value: string | number) => void;
 *
 *   containerClassName?: string;
 *   labelClassName?: string;
 *   itemsContainerClassName?: string;
 *
 *   itemContainerClassName?: string;
 *   itemClassName?: string;
 *   itemStyle?: React.CSSProperties | ((focused: boolean, selected: boolean) => React.CSSProperties);
 * }} props
 *
 * @returns {JSX.Element}
 */
export function RadioGroup({
  title,
  name,
  items,
  direction = 'column',

  value,
  onSelect,

  containerClassName,
  labelClassName,
  itemsContainerClassName,

  itemContainerClassName,
  itemClassName,
  itemStyle,
}) {
  const groupName = useId();

  return (
    <fieldset className={containerClassName}>
      {!!title && (
        <legend
          className={clsx(
            'block',
            'w-fit',
            'text-[16px] text-wtf-silver',
            'mb-[8px]',
            labelClassName,
          )}
        >
          {title}
        </legend>
      )}

      <div
        className={clsx(
          'flex gap-[16px]',
          direction === 'row' ? 'flex-row' : 'flex-col',
          itemsContainerClassName,
        )}
      >
        {items.map((item) => (
          <Radio
            key={item.value}
            value={item.value}
            label={item.label}
            name={groupName ?? name}
            selected={value === item.value}
            onSelect={onSelect}
            containerClassName={itemContainerClassName}
            className={itemClassName}
            style={itemStyle}
          />
        ))}
      </div>
    </fieldset>
  );
}
